import React from 'react'
import { connect } from 'react-redux'
import { setNavBarProps } from 'store/navbar'
import { modalActions } from 'store/modal'
import { USER_ROLE_IDS_CAN_EDIT_STUDY_VERSION_DETAILS } from 'utils/constants'
import { getUserRoleId } from 'utils/misc'
import { actions as studyActions } from '../modules/CreateStudy'
import EditStudyVersionPopup from '../components/EditStudyVersionPopup'
import { getStudyVersionID } from '../../../../../utils/studyConfigUtils'

const mapState = state => {
  const { user, study, location } = state
  const { currentStudy, studyVersionList } = study
  const studyVersionID = getStudyVersionID(location)

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isStudyVersionDetailsSectionEditable = USER_ROLE_IDS_CAN_EDIT_STUDY_VERSION_DETAILS.includes(
    getUserRoleId(user, study?.id),
  )

  const currentStudyVersion = studyVersionList?.find(version => version?.version_id === studyVersionID)

  return {
    study: currentStudy,
    studyVersionList,
    isStudyVersionDetailsSectionEditable,
    hasStudyPromotion,
    userId: user?.id,
    studyId: study?.currentStudy?.id,
    studyVersionID,
    currentStudyVersion,
  }
}

const mapDispatch = { ...modalActions, ...studyActions, setNavBarProps }

export default connect(
  mapState,
  mapDispatch,
)(props => {
  return <EditStudyVersionPopup {...props} />
})
